const en = {
  shake_title: 'Shake to Win',
  shake_start_shaking: 'Shake your phone',
  shake_chose_gifts_desc: '',
  shake_choose_gift: 'Choose your favourite…',
  shake_again_tomorrow: 'Shake again tomorrow',
  shake_buy_another_today: 'Do you want to Shake again?',
  shake_another_left_today: 'Another try left for today',
  shake_button_continue: 'Continue',
  shake_button_redeem: 'Activate',
  shake_button_buy: 'Buy',
  shake_button_go_back: 'Back',
  shake_button_try_again: 'Try again',
  shake_button_customer_support: 'Customer support',
  shake_button_recharge: 'Recharge',
  shake_button_close: 'Close',
  shake_button_error_general: 'Something went wrong',
  shake_back_to_dashboard: 'Back',
  shake_button_upgrade_gift: 'Yes, upgrade for %1$s %2$s',
  shake_button_continue_free: 'Continue with free gift',
  shake_button_yes_continue: 'Yes, continue',
  shake_price_unit: '%1$s %2$s',
  shake_you_selected: 'You have choosen %1$s',
  shake_you_selected_promo: 'You have selected %1$s for %2$s %3$s',
  shake_multiply_selected: 'You can multiple your reward and get %1$s for %2$s %3$s',
  shake_zbulo_ofertat: 'Explore offers',
  shake_re_shake: 'Shake again',
  shake_free_gift: 'Gifts',
  shake_shake_again: 'Shake again',
  shake_again_amount_vcoins: '%1$s %2$s to shake',
  shake_quote_share: 'Share',
  shake_explore_offers_title: 'Explore offers',
  shake_explore_offers_desc: 'Explore the list of offers available only for you!',
  shake_no_credit: 'You don’t have sufficient credit available',
  shake_loan_credit: 'Would you like to borrow %1$s %2$s?',
  shake_loan_limit: 'You have reached your loan limit',
  shake_fitove_product: 'You got %1$s',
  shake_try_now: 'Try now',
  shake_later_today: 'Try later',
  shake_not_enough_vcoins: 'Not enough VCoins',
  shake_not_enough_balance: 'Not enough Balance',
  shake_got_to_recharge: 'Recharge',
  shake_label_coupon: 'Coupon',
  shake_label_vcoins: 'VCoins',
  shake_label_quote: 'Quote',
  shake_modal_header_info: 'Info',
  shake_url_info: 'https://api-web-ci-vfal.vodafone.com/file/shake/more_info/Shake_Info_EN.html',
  shake_web_start_shaking: 'Start Shaking'
}

export default en
